import {
  CmpTextField,
  CmpButton,
  CmpTextFieldEnter,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Grid } from '@mui/material';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { CircularProgress } from "@mui/material";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import Dispatch_Breadcrumbs from "./Dispatch_BreadCrumbs";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { DispatchHead_Status_Set } from "./SliceDispatch";
// import { InstantPickingHead_Status_Set } from '../Instant/SliceInstantPickingHead';
// import { InstantPickingHead_Status_Set } from './SliceDispatch';
import useMediaQuery from "@mui/material/useMediaQuery";

import "./Dispatch.css";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import { DispatchDetailTblCard } from "./component/DispatchDetailTblCard";
import { DispatchVarianceTblCard } from "./component/DispatchVarianceTblCard";
const columns = [
  {
    field: "VFD_SrNo",
    headerName: "Sr No",
    width: 50,
  },
  {
    field: "VFD_ItmCd",
    headerName: "Item Code",
    width: 90,
  },
  {
    field: "ItmName",
    headerName: "Item Name",
    width: 250,
  },
  // {
  //     field: 'picked',
  //     headerName: 'Picked',
  //     width: 80,
  // },
  // {
  //     field: 'BinName',
  //     headerName: 'Bin Name',
  //     width: 100,
  // },
  {
    field: "VFD_Barcode",
    headerName: "Barcode",
    width: 100,
  },
  {
    field: "VFD_CardID",
    headerName: "CardID",
    width: 100,
  },
  {
    field: "VFD_Qty",
    headerName: "Qty",
    width: 100,
  },
  {
    field: "VFD_Unit",
    headerName: "Unit Code",
    width: 100,
  },
  {
    field: "VFD_BaseQty",
    headerName: "Base Qty",
    width: 100,
  },
];
const VarianceColumns = [
  {
    field: "ItmCd",
    headerName: "Item Code",
    width: 90,
  },
  {
    field: "Name1",
    headerName: "Item Name",
    width: 250,
  },
  // {
  //     field: 'picked',
  //     headerName: 'Picked',
  //     width: 80,
  // },
  {
    field: "INVQty",
    headerName: "INVQty",
    width: 100,
  },
  {
    field: "DispatchedQty",
    headerName: "DispatchedQty",
    width: 100,
  },
  {
    field: "Difference",
    headerName: "Difference",
    width: 100,
  },
];
export default function DispatchDetail() {
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const DispatchDetailBarcodeFocusOnLoad = useRef(null);
  const vRdxDetail = useSelector(
    (state) => state.SliceDispatch.value.DispatchHead
  );
  const [sLoading, setLoading] = useState(false);
  const [sGridRow, setGridRow] = useState([]);
  const [sGridVarienceRow, setGridVarienceRow] = useState([]);
  const [sDetailObj, setDetailObj] = useState({
    SrNo: 0,
    BarCode: "",
    Qty: 1,
  });
  let vDetailObjInit = {
    SrNo: 0,
    BarCode: "",
    Qty: 1,
  };
  const [sErrorMsg, setErrorMsg] = useState({
    SrNo: "",
    BarCode: "",
    Qty: "",
  });

  let vErrorInit = {
    SrNo: "",
    BarCode: "",
    Qty: "",
  };

  const [sOpenDetailViewModel, setOpenDetailViewModel] = useState(false);
  const sEnterKeyObj = {
    key: "Enter",
  };
  const fCloseDetailViewModel = () => {
    setOpenDetailViewModel(false);
  };

  const fOpenDetailViewModel = () => {
    setOpenDetailViewModel(true);
  };
  const [sOpenPostVarianceModel, setOpenVarianceModel] = useState(false);

  const fCloseVarianceModel = () => {
    setOpenVarianceModel(false);
  };

  const fOpenVarianceModel = () => {
    setOpenVarianceModel(true);
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      fSave();
    }
  };

  const fOnChangeInput = (e) => {
    setDetailObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnChangeInputQty = (e) => {
    // if (e.target.value  0) {
    //     setDetailObj((obj) => ({
    //         ...obj,
    //         [e.target.name]:Number(e.target.value +1),
    //     }));
    // } else {
    //     setDetailObj((obj) => ({
    //         ...obj,
    //         [e.target.name]: Number(e.target.value),
    //     }));
    // }
    setDetailObj((obj) => ({
      ...obj,
      [e.target.name]: Number(e.target.value),
    }));
  };
  const xonFocus = (e) => {
    if (e.target.value == 0) {
      setDetailObj((obj) => ({
        ...obj,
        [e.target.name]: Number(e.target.value + 1),
      }));
    }
  };
  const onBlur = (e) => {
    if (e.target.value == "" || e.target.value == 0) {
      setDetailObj((obj) => ({
        ...obj,
        [e.target.name]: Number(e.target.value + 1),
      }));
    }
  };

  const setValidation = () => {
    setErrorMsg(vErrorInit);
    let iRes = true;
    if (sDetailObj.SrNo === "") {
      setErrorMsg((obj) => ({ ...obj, SrNo: "SrNo is Empty" }));
      iRes = false;
    }
    if (sDetailObj.BarCode === "") {
      setErrorMsg((obj) => ({ ...obj, BarCode: "BarCode is Empty" }));
      iRes = false;
    }
    if (sDetailObj.Qty === "") {
      setErrorMsg((obj) => ({ ...obj, Qty: "Qty is Empty" }));
      iRes = false;
    } else if (sDetailObj.Qty <= 0) {
      setErrorMsg((obj) => ({ ...obj, Qty: "Qty is Zero" }));
      iRes = false;
    }

    return iRes;
  };
  let timeout = null;
  const fSave = async (e) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (setValidation()) {
        let vResp = await GetSaveItems();
        if (vResp?.Type?.toUpperCase() == "SUCCESS") {
          fAlertToast("SUCCESS", "Successfully Saved");
          fNew();
        }
      }
    }, 800);
  };

  const fDelete = (e) => {
    confirmAlert({
      title: "Delete",
      message: "Are you sure you want to Delete?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: async () => {
            fClearErrorMsg();
            let vResp = await GetDeleteItems();
            if (vResp?.Type?.toUpperCase() == "SUCCESS") {
              fAlertToast("SUCCESS", "Successfully Deleted");
              fNew();
            }
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => console.log("no"),
        },
      ],
    });
    // let vResp = await GetDeleteItems();
    // if (vResp.Type == "SUCCESS") {
    //     fAlertToast("SUCCESS","Successfully Deleted")
    //     fNew();
    // }
  };

  // const fDeleteConfirmed = async (e) => {
  //     fClearErrorMsg();
  //     let vResp = await GetDeleteItems();
  //     if (vResp.Type == "SUCCESS") {
  //         fAlertToast("SUCCESS", "Successfully Deleted")
  //         fNew();
  //     }
  // }

  const fClearErrorMsg = (e) => {
    setErrorMsg(vErrorInit);
  };

  const fNew = async (e) => {
    fClearErrorMsg();
    setDetailObj(vDetailObjInit);
    GetItems();
    document.getElementById("BarCode")?.focus();
  };

  const fPost = (e) => {
    fClearErrorMsg();
    GetPostDispatch();
  };

  const fVariance = (e) => {
    GetVariance();
    fOpenVarianceModel();
  };
  const fDetail = (e) => {
    fOpenDetailViewModel();
  };

  //API DISPATCH_GETITEMS_GETROW
  const GetItems = async () => {
    let vItemsObj = {
      vocTyp: vRdxDetail.VocTyp,
      vocNo: vRdxDetail.VocNo,
    };
    const vItems = await fExecuteAPI("DISPATCH_GETITEMS_GETROW", vItemsObj);
    if (vItems?.Type?.toUpperCase() == "SUCCESS") {
      let GridID = vItems.ResultSet?.map((obj, i) => ({ ...obj, id: i + 1 }));
      setGridRow(GridID);
    } else if (vItems?.Type?.toUpperCase() == "FAILED") {
      fAlertToast("FAILED", vItems.Message);
    } else if (vItems.response.status == 500 || vItems.response.status == 400) {
      fAlertToast("FAILED", vItems.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in loading summarylist");
    }
  };

  //API DISPATCH_DELETE_ITEMS_GETROW
  const GetDeleteItems = async () => {
    let vDeleteItemsObj = {
      vocTyp: vRdxDetail.VocTyp,
      vocNo: vRdxDetail.VocNo,
      srNo: sDetailObj.SrNo,
    };
    const vDeleteItems = await fExecuteAPI(
      "DISPATCH_DELETE_ITEMS_GETROW",
      vDeleteItemsObj
    );
    if (vDeleteItems?.Type?.toUpperCase() === "SUCCESS") {
      return vDeleteItems;
    } else {
      fAlertToast(
        "FAILED",
        vDeleteItems.Message ||
          vDeleteItems.response.data.Status ||
          "Error in deleting"
      );
      return vDeleteItems;
    }
  };
  //API DISPATCH_VARIANCE_ITEMS_GETROW
  const GetVariance = async () => {
    let vVarianceObj = {
      vocTyp: vRdxDetail.VocTyp,
      vocNo: vRdxDetail.VocNo,
    };
    const vVariance = await fExecuteAPI(
      "DISPATCH_VARIANCE_ITEMS_GETROW",
      vVarianceObj
    );
    if (vVariance.Type == "SUCCESS") {
      let GridID = vVariance.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridVarienceRow(GridID);
    } else if (vVariance.Type == "FAILED") {
      fAlertToast("FAILED", vVariance.Message);
    } else if (
      vVariance.response.status == 500 ||
      vVariance.response.status == 400
    ) {
      fAlertToast("FAILED", vVariance.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in deleting");
    }
  };
  //API DISPATCH_POSTDISPATCH_ITEMS_GETROW
  const GetPostDispatch = async () => {
    let vPostDispatchObj = {
      vocTyp: vRdxDetail.VocTyp,
      vocNo: vRdxDetail.VocNo,
    };
    const vPostDispatch = await fExecuteAPI(
      "DISPATCH_POSTDISPATCH_ITEMS_GETROW",
      vPostDispatchObj
    );
    if (vPostDispatch.Type == "SUCCESS") {
      // setsInstantPickingDetail((obj) => ({ ...obj, Status: "Completed" }));
      dispatch(DispatchHead_Status_Set({ Status: "Completed" }));
      fAlertToast("SUCCESS", "Successfully posted");
      fNew();
    } else if (vPostDispatch.Type == "FAILED") {
      fAlertToast("FAILED", vPostDispatch.Message);
    } else if (
      vPostDispatch.response.status == 500 ||
      vPostDispatch.response.status == 400
    ) {
      fAlertToast("FAILED", vPostDispatch.response.data.Status);
    } else {
      fAlertToast("FAILED", "Error in deleting");
    }
  };

  //API DISPATCH_SAVE_ITEMS_GETROW
  const GetSaveItems = async () => {
    let vSaveItemsObj = {
      vocTyp: vRdxDetail.VocTyp,
      vocNo: vRdxDetail.VocNo,
      srNo: sDetailObj.SrNo,
      barcode: sDetailObj.BarCode,
      qty: sDetailObj.Qty > 0 ? Number(sDetailObj.Qty) : 1,
    };
    const vSaveItems = await fExecuteAPI(
      "DISPATCH_SAVE_ITEMS_GETROW",
      vSaveItemsObj
    );
    if (vSaveItems.Type == "SUCCESS") {
      return vSaveItems;
    } else if (vSaveItems.Type == "FAILED") {
      fAlertToast("FAILED", vSaveItems.Message);
      return vSaveItems;
    } else if (
      vSaveItems.response.status == 500 ||
      vSaveItems.response.status == 400
    ) {
      fAlertToast("FAILED", vSaveItems.response.data.Status);
      return vSaveItems;
    } else {
      fAlertToast("FAILED", "Error in loading Item");
      return vSaveItems;
    }
  };

  const fGridRowData = (e) => {
    // e.row
    setDetailObj((obj) => ({
      ...obj,
      SrNo: e.row.VFD_SrNo,
      BarCode: e.row.VFD_Barcode,
      Qty: e.row.VFD_Qty,
    }));
    fCloseDetailViewModel();
  };

  useEffect(() => {
    GetItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sVarianceColumns, setVarianceColumns] = useState([]);
  const [scolumns, setcolumns] = useState([]);

  useEffect(() => {
    GetGitterColumns(setcolumns, "WMSDISPATCH_DETAIL", columns);
    GetGitterColumns(
      setVarianceColumns,
      "WMSDISPATCH_VARIANCE",
      VarianceColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    DispatchDetailBarcodeFocusOnLoad.current?.focus();
  }, []);
  return (
    <div className="container-fluid py-2 ">
      <div className="Breadcrumbs">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <Dispatch_Breadcrumbs />
      </div>
      <div className="Instantg-picking-detail">
        <Box sx={{ flexGrow: 1 }} className="xs-instant-picking-detail-label">
          <Grid container spacing={2} columns={{ xs: 24, sm: 12, md: 12 }}>
            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 10, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Doc.Type</label>
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Doc.Type"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.VocTyp}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocTyp"}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Doc.Name"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.VocTypName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocTypName"}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 2, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Doc.No</label>
                </Grid>
                <Grid item xs={10}>
                  <CmpTextField
                    xLabelText={"Doc.No"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.VocNo}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"VocNo"}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 10, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Party</label>
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"Party"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.Party}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"Party"}
                  />
                </Grid>
                <Grid item xs={5}>
                  <CmpTextField
                    xLabelText={"PartyName"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.PartyName}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"PartyName"}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={8} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 2, sm: 12, md: 12 }}>
                <Grid item xs={2}>
                  <label className="title-f ">Status</label>
                </Grid>
                <Grid item xs={10}>
                  <CmpTextField
                    xLabelText={"Status"}
                    xVariant={"standard"}
                    xValue={vRdxDetail.Status}
                    xOnChange={""}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"Status"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <br></br>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} columns={{ xs: 24, sm: 12, md: 12 }}>
            <Grid item xs={24} sm={12} md={12}>
              <Grid container spacing={2} columns={{ xs: 4, sm: 12, md: 12 }}>
                <Grid item xs={4}>
                  <CmpTextField
                    xLabelText={"SrNo"}
                    xVariant={"outlined"}
                    xValue={sDetailObj.SrNo}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={true}
                    xType={"text"}
                    xName={"SrNo"}
                    xError={sErrorMsg.SrNo === "" ? false : true}
                    xErrorMessage={sErrorMsg.SrNo}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CmpTextField
                    xLabelText={"Qty"}
                    xVariant={"outlined"}
                    xValue={sDetailObj.Qty}
                    xOnChange={(event) => fOnChangeInputQty(event)}
                    xReadOnly={false}
                    xType={"number"}
                    xName={"Qty"}
                    xError={sErrorMsg.Qty === "" ? false : true}
                    xErrorMessage={sErrorMsg.Qty}
                    xonFocus={xonFocus}
                    xonBlur={onBlur}
                  />
                </Grid>
                <Grid item xs={4}>
                  <CmpTextFieldEnter
                    xref={DispatchDetailBarcodeFocusOnLoad}
                    xLabelText={"BarCode"}
                    xVariant={"outlined"}
                    xValue={sDetailObj.BarCode}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"BarCode"}
                    xOnKeyUp={(e) => {
                      fOnKeyUp(e);
                    }}
                    xError={sErrorMsg.BarCode === "" ? false : true}
                    xErrorMessage={sErrorMsg.BarCode}
                    xOnEnter={(e) => {
                      fOnKeyUp(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <br></br>
        <Box sx={{ flexGrow: 1 }}>
          <Grid
            container
            spacing={1}
            columns={{ xs: 6, sm: 12, md: 10 }}
            className="text-center"
          >
            <Grid item xs={2}>
              <CmpButton
                xbtnName="New"
                xOnClick={fNew}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Save"
                xOnClick={fSave}
                xVariant="contained"
                xDisabled={vRdxDetail.Status === "Completed"}
                xSize="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Delete"
                xOnClick={fDelete}
                xVariant="contained"
                xDisabled={vRdxDetail.Status === "Completed"}
                xSize="small"
              />
            </Grid>
            <Grid item xs={2} className=" btn-instant-picking-Detail">
              <CmpButton
                xbtnName="Detail"
                xOnClick={fDetail}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Post"
                xOnClick={fPost}
                xVariant="contained"
                xDisabled={vRdxDetail.Status === "Completed"}
                xSize="small"
              />
            </Grid>
            <Grid item xs={2}>
              <CmpButton
                xbtnName="Variance"
                xOnClick={fVariance}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
              />
            </Grid>
          </Grid>
        </Box>

        <br></br>
        <div className="container-fluid mt-3">
          <div className="xs-instant-picking-detail-grid">
            <Box sx={{ height: vMediaQuery ? "70vh" : "40vh", width: "100%" }}>
              {/* <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sGridRow}
                columns={scolumns}
                // pageSize={5}
                // rowsPerPageOptions={[5]}
                hideFooter={sGridRow.length < 100}
                onRowClick={fGridRowData}
                components={{
                  Toolbar: GridToolbar,
                }}
              /> */}

              <DispatchDetailTblCard data={sGridRow} onClick={fGridRowData}/>
            </Box>
          </div>
        </div>
      </div>
      <Modal
        open={sOpenDetailViewModel}
        onClose={fCloseDetailViewModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <div>
            <GCTitleSticky title={"Grid"} onClose={fCloseDetailViewModel} />
            {/* <div className="d-flex justify-content-end">
              <CloseIcon onClick={fCloseDetailViewModel} />
            </div> */}
            {sLoading ? (
              <div
                style={{
                  height: "22rem",
                  width: "90%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "1rem",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Box
                style={{ height: vMediaQuery ? "70vh" : "70vh", width: "100%" }}
                className="bintransfer-out-grid"
              >
                {/* <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridRow}
                  columns={scolumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  hideFooter={sGridRow.length < 100}
                  onRowClick={fGridRowData}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                /> */}
                   <DispatchDetailTblCard data={sGridRow} onClick={fGridRowData}/>
              </Box>
            )}
          </div>
        </Box>
      </Modal>

      <Modal
        open={sOpenPostVarianceModel}
        onClose={fCloseVarianceModel}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <div>
            <GCTitleSticky title={"Variance"} onClose={fCloseVarianceModel} />
            {/* <div className="d-flex justify-content-end">
              <CloseIcon onClick={fCloseVarianceModel} />
            </div> */}
            {sLoading ? (
              <div
                style={{
                  height: "22rem",
                  width: "90%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "1rem",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Box
                style={{ height: vMediaQuery ? "70vh" : "65vh", width: "100%" }}
                className="bintransfer-out-grid"
              >
                {/* <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sGridVarienceRow}
                  columns={sVarianceColumns}
                  // pageSize={5}
                  // rowsPerPageOptions={[5]}
                  hideFooter={sGridRow.length < 100}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                /> */}
                <DispatchVarianceTblCard data={sGridVarienceRow} />
              </Box>
            )}
          </div>
        </Box>
      </Modal>
    </div>
  );
}
